<template>
	<el-container class="home_container">
		<el-aside width="200px" class="menu_box">
			<div class="menu_user">
				<div class="mt20 rx-c">
					<img class="w40 v_a_m ml25" :src="userInfo.logoUrl" alt="">
					<span class="color-fff fwb ml10 v_a_m d_i_b w115" :class="userInfo.logingName.length > 7 ? 'ft14 menu_user_span' : 'ft16'">{{ userInfo.logingName }}</span>
				</div>
			</div>
		    <el-menu 
		     	active-text-color="#ffd04b"
		        background-color="#001529"
		        class="mt20"
		        :default-active="currentMenu.url"
				:default-openeds="['1']"
		        text-color="#fff"
		        router
				@select="handleSelect"
		        unique-opened>
		      	<div v-for="item in menuLeft" :key="item.id">
					<el-sub-menu v-if="!item.url" :index="item.id">
			            <template #title>
			            		<img :src="[item.id == currentMenu.id ? item.iconSelected : item.icon]" class="w20 h20 mr5 mb5">
			                	<span>{{item.name}}</span>
			            </template>
			            <el-menu-item class="mb5" v-for="subItem in item.list" :key="subItem" :index="subItem.url">
				            <span>{{subItem.name}}</span>
				        </el-menu-item>
			        </el-sub-menu>
			        <el-menu-item v-if="item.url" :index="item.url">
						<img :src="[item.id == currentMenu.id ? item.iconSelected : item.icon]" class="w20 h20 mr5 mb5">
			            <span>{{item.name}}</span>
			        </el-menu-item>
		      	</div>
		    </el-menu>
		</el-aside>
		<el-container>
			<el-header>
				<div class="rx-bc h50" style="border-bottom: 1px solid #00000016;">
					<div class="c_p pl20">
                        
                    </div>
					
					<div class="w500 h50 rx-ec">
						<div class="mr20 ml10">
                            <el-dropdown>
                                <div class="h50 rx-cc color-main">
                                  <span>{{userInfo.realName}}</span>
                                  <el-icon class="el-icon--right">
                                    <CaretBottom></CaretBottom>
                                    <!-- <arrow-down style="color:#fff;"/> -->
                                  </el-icon>
                                </div>
                                <template #dropdown>
                                  <el-dropdown-menu>
                                    <el-dropdown-item @click="outLogin">退出登录</el-dropdown-item>
                                  </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
					</div>
				</div>
			</el-header>
			<el-main class="home_main" style="padding:0 !important;">
				    <keep-alive :include="store.state.keepLiveRoute">
						<router-view v-slot="{ Component }">
				           <component :is="Component" @update="updateStoreName"/>
					    </router-view>
				    </keep-alive>
			</el-main>
		</el-container>
	</el-container>
</template>

<script setup>
	import {ref,reactive,onMounted, onBeforeUnmount} from 'vue'
	import {useRouter} from 'vue-router';
	import { useStore } from 'vuex'
	import { ElMessage, ElLoading } from 'element-plus'
	import {Download,CaretBottom} from '@element-plus/icons-vue'
	import {getLocalStorage} from '@/common/common.js';
	import utils from '@/common/utils.js'
	const router = useRouter();
	const store = useStore();
	const nowStoreData = getLocalStorage('businessNowStoreData');
	const userInfo = getLocalStorage('businessUserData')
	var menuLeft = ref([]);
	const currentMenu = reactive({
		id : '102',
		url : 'storeList',
		nav : ['营销后台','分店管理']
	})

	//退出登录
	function outLogin() {
		var access_token = getLocalStorage('businessLoginData').access_token;
		//执行退出接口
		// logout({access_token}).then((res)=>{
			// if(res.code == 0){
				ElMessage({
					message:'退出成功',
					type: 'success'
				})
				setTimeout(()=>{
					localStorage.clear();
					sessionStorage.clear();
					router.push('/login');
				},1000)
			// }
		// })
	}
	function _getMenuItemByPath(path){
		path = path.indexOf('?') > -1 ? path.split('?')[0] : path
		var menuSelect = null;
	  	function getSelectItem(menuList){
	  		if(!menuList){
	  			return null;
	  		}
	  		for(var i=0;i<menuList.length;i++){
	  			if(menuList[i]['url'] == path){
	  				menuSelect = Object.assign({},menuList[i]);
	  				break;
	  			}
	  			if(menuList[i]['list'] && menuList[i]['list'].length > 0){
					getSelectItem(menuList[i]['list']);
	  			}
	  		}
	  	}
	  	getSelectItem(menuLeft.value);
	  	return menuSelect;
	}
	function initMenuLeft(){
		const businessMenuList = getLocalStorage('businessMenuList');
		var tempMenuArray = [];
			var navObj = {
			1 : ['营销后台'],
			102 : ['营销后台','分店管理'],
			101 : ['营销后台','总部管理'],
			2 : ['系统管理'],
			201 : ['系统管理','员工管理'],
		};
		function addUrlMenu(level,item, index){
			var tempItem = {
				name : item['menuName'],
				id : item['id']+''
			}
			if(level == 1){
				tempItem['icon'] = require('../../assets/home/menu_icon'+ (index + 1) +'.png');
				tempItem['iconSelected'] = require('../../assets/home/select_menu_icon'+ (index + 1) +'.png');
			}
			if(item['menuUrl'] && level != 1){
				tempItem['url'] = item['menuUrl'];
			}
			if(item['list'] && item['list'].length > 0){
				var list = [];
				for(var i=0;i<item['list'].length;i++){
					list.push(addUrlMenu(level + 1,item['list'][i]));
				}
				tempItem['list'] = list;
			}
			tempItem['nav'] = navObj[tempItem['id']];
			return tempItem;
		}

		for(var i=0;i<businessMenuList.length;i++){
			tempMenuArray.push(addUrlMenu(1,businessMenuList[i], (i+1)));
		}
		menuLeft.value = tempMenuArray;
		flushPageUrl();
	}
	function flushPageUrl(url){
		var currentUrl = url || location.href.split('#')[1].replace('/','');
		var currentNowMenu = _getMenuItemByPath(currentUrl);
		if(currentNowMenu){
			currentMenu['id'] = currentNowMenu['id'];
			currentMenu['url'] = currentNowMenu['url'];
			currentMenu['nav'] = currentNowMenu['nav'];
		}
	};
	const handleSelect = (key, keyPath) => {
		localStorage.setItem('mainHome', key)
	  	flushPageUrl(key);
	}
    onMounted(()=>{
		if (localStorage.getItem('mainHome') != null) {
            flushPageUrl(localStorage.getItem('mainHome'))
	    }
		initMenuLeft();
    });
	onBeforeUnmount(() => {
		localStorage.removeItem('mainHome')
	})
</script>

<style lang="stylus" scoped>
	.home_container{
		position absolute;
		left 0;
		right 0;
		bottom 0;
		top 0;
		.menu_box{
			background-color #001529;
			.menu_user_span{
				display: -webkit-box; 
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
			.menu_ul{
				li{
					height 40px;
					line-height 40px;
					color white;
					cursor pointer;
					opacity .4;
				}
				li.nav{
					opacity 1;
				}
				li.nav.active{
					border-radius 0 100px 100px 0;
					background-color #E6F7FF !important;
					position relative;
					span{
						color #0486FE;
					}
				}
				li.nav:hover{
					border-radius 0 100px 100px 0;
					background-color #E6F7FF20;
					position relative;
				}
				li.nav.active::after,li.nav:hover::after{
					content '';
					position absolute;
					top 0;
					left 0;
					bottom 0;
					border-left 4px solid #0486FE;
				}
			}
		}
		.home_main{
			background-color #F5F5F5;
		}
	}
	.img_hover{
		opacity:0.65;
		width:16px;
	}
	.img_hover:hover{
		opacity:1;
		width:18px;
	}
	.el-divider--vertical{
		border-left:1px solid #00a3ff;
		margin-left:20px;
		margin-right:20px;
	}
</style>